import React from 'react'
import Icon from './Icon'
import PreviewImg from './previewImg'

export default function GenerateModal({ open, data, onClose, onRegenerate, onContinue, onDownload }) {
  return (
    <div className={`fdai-generate-modal ${open ? 'open' : ''}`}>
      {data && (
        <div className="fdai-generate-modal-inner">
          <div className="fdai-generate-modal-header">
            <span className="fdai-generate-modal-title">{data.tabLabel}
              <span className="fdai-generate-modal-title-desc">
                你可以离开本页面，并在历史记录中查收生成结果
              </span>
            </span>
            <button className="fdai-generate-modal-close" onClick={onClose}>
              <Icon type="zykj-guanbi" />
            </button>
          </div>

          <div className="fdai-generate-refs">
            <div className="fdai-generate-ref-group">
              <span className="fdai-generate-ref-label">参考商品</span>
              <div className="fdai-generate-ref-imgs">
                {data.refProduct && (
                  <div className="fdai-generate-ref-item">
                    <PreviewImg side="bottom" overlayClassName="fdai-scroll-preview-tooltip">
                      <img src={data.refProduct} alt="" />
                    </PreviewImg>
                  </div>
                )}
              </div>
            </div>
            {data.refImgs?.length > 0 && (
              <div className="fdai-generate-ref-group">
                <span className="fdai-generate-ref-label">参考图</span>
                <div className="fdai-generate-ref-imgs">
                  {data.refImgs.map((url, i) => (
                    <PreviewImg key={`${url}-${i}`} side="bottom" overlayClassName="fdai-scroll-preview-tooltip">
                      <img src={url} alt="" className="fdai-generate-ref-item" />
                    </PreviewImg>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="fdai-generate-results-wrap">
            <span className="fdai-generate-results-title">生成结果</span>
            <div className="fdai-generate-results">
              {data.status === 'generating' ? (
                <div className="fdai-generate-result-item generating">
                  <div className="fdai-generate-gradient-placeholder" />
                  <div className="fdai-generate-progress-tag">
                    <span>作品生成中</span>
                  </div>
                </div>
              ) : data.status === 'fail' ? (
                <div className="fdai-generate-result-item fail">
                  <Icon type="icon-tupian1" />
                  <div className="fdai-generate-result-buttons">
                    <button className="fdai-generate-result-btn" onClick={onRegenerate}>
                      <Icon type="icon-zhongxinshengcheng" />
                      <span className="fdai-generate-result-btn-text">重新生成</span>
                    </button>
                  </div>
                </div>
              ) : (
                <div className="fdai-generate-result">
                  <img src={data.results} alt="result" />
                  <div className="fdai-generate-result-buttons">
                    <button className="fdai-generate-result-btn" onClick={onRegenerate}>
                      <Icon type="icon-zhongxinshengcheng" />
                      <span className="fdai-generate-result-btn-text">重新生成</span>
                    </button>
                    <button className="fdai-generate-result-btn" onClick={onContinue}>
                      <Icon type="icon-dapei1" />
                      <span className="fdai-generate-result-btn-text">继续改款</span>
                    </button>
                    <button className="fdai-generate-result-btn" onClick={() => onDownload(data.results, data.workId)}>
                      <Icon type="icon-xiazai1" />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
